import { StoreLocatorControllerWithLocation as StoreLocatorController } from './store-locator.controller';

export * from './store-locator.messages';
export * from './store-locator.constants';
export * from './components/store-address/store-address.component';
export * from './components/prices-grid/prices-grid-controller.component';

export default StoreLocatorController;
